<template>
    <div class="add">
        <el-form :model="formData" label-width="100px" :rules="rules" ref="formData">
            <el-form-item label="院区">
                <el-select v-model="formData.areaId" placeholder="请选择院区" style="width:95%;" clearable>
                    <el-option v-for="(item) in ranks" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="科室">
                <el-select v-model="formData.dsepartmentCode" placeholder="请选择科室" style="width:95%;" clearable>
                    <el-option v-for="(item) in departments" :key="item.id" :label="item.departmentName" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="姓名" prop="clientName">
                <el-input v-model.trim="formData.clientName" style="width:95%;" clearable placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="clientMobile">
                <el-input oninput="value=value.replace(/[^0-9.]/g, '')" v-model.trim="formData.clientMobile" style="width:95%;" clearable placeholder="请输入手机号"> </el-input>
            </el-form-item>
            <el-form-item label="手术时间">
                <el-date-picker :picker-options="options" style="width:95%;" v-model="formData.operationTime" type="date" placeholder="选择手术时间" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="文件">
                <!-- <el-input type="file" v-model.trim="formData.identityName" style="width:95%;"></el-input> -->
                <input class="filebox" type="file" name="file" ref="imgFile" id='upFile'>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="cancel">取 消</el-button>
            <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapState(['departments']),
    },
    props: ['formData'],

    data() {
        const validPhone = (rule, value, callback) => {

            if (!value) {
                callback(new Error('请输入手机号码'))
            } else {
                callback()
            }

        }
        return {
            ranks: this.$store.state.ranks,
            rules: {
                clientMobile: [{ required: true, trigger: 'blur', validator: validPhone }],
                clientName: [{ required: true, message: "请填写姓名", trigger: "blur" }],
            },
            options: {
                // 设置禁用状态，参数为当前日期
                disabledDate(time) {
                    // return time.getTime() < Date.now(); //当天不可选
                    return time.getTime() > Date.now() //  - 86400000是否包括当天
                },
            },
        }
    },

    methods: {
        doAddgoods(formData) {
            this.$refs[formData].validate((valid) => {
                if (valid) {
                    var file = document.getElementById("upFile").files[0]; //获取文件
                    this.formData.createBy = Lockr.get('skinEmpId')
                    let data = {
                        clientName: this.formData.clientName,
                        clientMobile: this.formData.clientMobile,
                        areaId: this.formData.areaId,
                        dsepartmentCode: this.formData.dsepartmentCode,
                        operationTime: this.formData.operationTime,
                        createBy: this.formData.createBy,
                    }
                    var formData = new FormData();
                    console.log(file);
                    formData.append("file", file)
                    formData.append("electronicCase", JSON.stringify(data))
                    api.requestQuiet("/register/createElectronicCase", formData, (res) => {
                        if (res.result == true) {
                            this.$emit("close");
                            this.$emit("add-comment");
                            _g.toast("success", '文件上传成功');
                            var test = document.getElementById('upFile');
                            test.value = '';
                        } else {
                            _g.toast("error", res.errMsg);
                        }
                    }, (err) => { });
                } else {
                    _g.toast("warning", "请完善信息");
                    return false;
                }
            })
        },
        cancel() {
            this.$emit("close");
        },
    }
}
</script>

